import { Modal } from 'antd';
import { InfoCircleFilled } from '@ant-design/icons';
import { getCurrentI18n } from '../hooks/LanguageHooks';
import * as libCon from '../community-hats-js-library/Constants';
import { showError } from './generalFunctions';

export const showMessageDialog = (message, title = null) => {
  const i18n = getCurrentI18n();
  Modal.info({
    title: title,
    content: message,
    centered: true, // vertically center the dialog
    okText: i18n.t('understood'), // localized OK label
    icon: <InfoCircleFilled style={{ color: 'var(--primary-color-3)' }} />, // colored warning sign
    okButtonProps: {
      style: {
        backgroundColor: 'var(--primary-color-3)',
        borderColor: 'var(--primary-color-3)',
      },
    },
    maskClosable: false, // background click does NOT dismiss — only OK
    keyboard: false, // Esc does NOT dismiss — only OK
    styles: {
      mask: {
        backdropFilter: 'blur(4px)', // blur the background
        background: 'rgba(0, 0, 0, 0.35)', // slight dim so blur reads well
      },
    },
  });
};

export const showMessageDialogWithLanguageCode = (messageCode, titleCode = null) => {
  const i18n = getCurrentI18n();
  Modal.info({
    title: titleCode ? i18n.t(titleCode) : null,
    content: messageCode ? i18n.t(messageCode) : null,
    centered: true, // vertically center the dialog
    okText: i18n.t('understood'), // localized OK label
    icon: <InfoCircleFilled style={{ color: 'var(--primary-color-3)' }} />, // colored warning sign
    okButtonProps: {
      style: {
        backgroundColor: 'var(--primary-color-3)',
        borderColor: 'var(--primary-color-3)',
      },
    },
    maskClosable: false, // background click does NOT dismiss — only OK
    keyboard: false, // Esc does NOT dismiss — only OK
    styles: {
      mask: {
        backdropFilter: 'blur(4px)', // blur the background
        background: 'rgba(0, 0, 0, 0.35)', // slight dim so blur reads well
      },
    },
  });
};

export const showErrorDialog = (message) => {
  showError(message);
};

export const showErrorDialogByCode = (code) => {
  const i18n = getCurrentI18n();
  showError(`${i18n.t(libCon.ERRORS[code][libCon.MESSAGE])} (Code: ${libCon.ERRORS[code][libCon.CODE]})`);
};
